<template>
  <div id="app">
    <vue-progress-bar></vue-progress-bar>
    <nav id="nav" class="navbar fixed-top justify-content-center w-100 mb-5">
      <!-- <a href="#" class="navbar-brand">
          <img src="logoName.png" alt="" class="" height="64">
      </a>-->
      <router-link class="m-2" :to="{name: 'home'}">Welkom</router-link>
      <router-link class="m-2" :to="{name: 'geboortelijst'}">Lijst</router-link>
      <router-link class="m-2" :to="{name: 'contact'}">Contact</router-link>
      <router-link class="m-2" :to="{name: 'nieuw'}" v-if="currentUser && currentUser.email">Nieuw</router-link>
      <router-link
        class="m-2"
        :to="{name: 'reserveringen'}"
        v-if="currentUser && currentUser.email"
      >Reserveringen</router-link>
      <!-- <router-link class="m-2" :to="{name:'login'}" v-else>Login</router-link> -->
      <a href="#" v-if="currentUser && currentUser.email" class="m-2" @click="logout">Uitloggen</a>
    </nav>
    <div class="container mt-2">
      <transition name="fade" mode="out-in">
        <router-view min-height="300"/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState(["currentUser"])
  },
  methods: {
    ...mapActions(["logout"])
  },
  created() {
    this.$Progress.start()
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();

      next();
    });

    this.$router.afterEach((to, from) => {
      this.$Progress.finish();
    });
  },
  async mounted() {
    this.$Progress.finish();
    // initialize this.$firebase and fetch artikel list
    let fb = this.$firebase.firestore();
    fb.enablePersistence()
    if (!this.currentUser) {
      await this.$firebase.auth().signInAnonymously();
    }
    fb.collection("artikels").onSnapshot(
      snapshot => {
        let artikels = [];
        snapshot.forEach(doc => {
          let item = doc.data();
          item.id = doc.id;
          item.localImg =
            "/img/" +
            decodeURIComponent(
              this.$_.replace(
                this.$_.split(item.img, "?")[0],
                "https://this.$firebasestorage.googleapis.com/v0/b/projectkind-ebc5d.appspot.com/o/",
                ""
              )
            ) +
            ".png";
          artikels.push(item);
        });
        this.$store.commit("addArtikels", this.$_.shuffle(artikels));
      },
      err => {
        this.$alertify(
          "Oeps, de geboortelijst kon niet geladen worden, er ging iets mis.."
        );
      }
    );

    let snapshot = await fb.collection("homepage").get()
    let carousel = [];
    snapshot.forEach(doc => {
      let data = doc.data();
      data.id = doc.id;
      carousel.push(data);
    });
    this.$store.commit("setHomeCarousel", carousel);
    // fb.collection("homepage").onSnapshot(
    //   snapshot => {
    //     let carousel = [];
    //     snapshot.forEach(doc => {
    //       let data = doc.data();
    //       data.id = doc.id;
    //       carousel.push(data);
    //     });
    //     this.$store.commit("setHomeCarousel", carousel);
    //   },
    //   err => {
    //     this.$alertify.error(err);
    //   }
    // );
  }
};
</script>

<style>
html {
  margin-left: calc(100vw - 100%);
  overflow-y: scroll;
  overflow-x: hidden;
}
body {
  overflow-x: hidden;
  padding-top: 5rem;
}
#app {
  color: #2c3e50;
}
#nav {
  text-align: center;
  background-color: white;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter, .fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
div[data-glide-el="controls"] {
  position: absolute;
  left: 0;
  right: 0;
  top: 40%;
}
button[data-glide-dir="<"],
button[data-glide-dir=">"] {
  position: absolute;
  border: 0;
  outline: 0;
  padding: 10px;
  border-radius: 3px;
  background-color: #eee;
  opacity: 0.7;
  color: #17a2b8;
  cursor: pointer;
}
button[data-glide-dir="<"]:hover,
button[data-glide-dir=">"]:hover {
  opacity: 1;
}
button[data-glide-dir=">"] {
  right: 5px;
}
button[data-glide-dir="<"] {
  left: 5px;
}
.glide__slide pre {
  display: flex;
  height: 200px;
  align-items: center;
  justify-content: center;
}
.glide__slide--active pre {
  background-color: #497cdd !important;
}
.glide__bullets {
  text-align: center;
}
.glide__bullet {
  background-color: #eee;
  border: 0;
  outline: 0;
  width: 15px;
  height: 15px;
  border-radius: 100%;
  cursor: pointer;
}
.glide__bullet:hover {
  background-color: #d5d5d5;
}
.glide__bullet + .glide__bullet {
  margin-left: 10px;
}
.glide__bullet--active {
  background-color: #497cdd;
}
.action-button {
  display: inline-block;
  background-color: #3eaf7c;
  color: #fff;
  padding: 15px 30px;
  border-radius: 3px;
  margin: 30px 0;
}
.action-button:hover {
  background-color: #379c6f;
}

.navbar {
  border-width: 0px;
}
</style>

